import React, { useState } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Box, IconButton, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import CurrencyExchangeOutlinedIcon from "@mui/icons-material/CurrencyExchangeOutlined";
import DiscountIcon from "@mui/icons-material/Discount";
import FormatListNumberedRtlIcon from "@mui/icons-material/FormatListNumberedRtl";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import HomeIcon from "@mui/icons-material/Home";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PaidIcon from "@mui/icons-material/Paid";
import RedeemIcon from "@mui/icons-material/Redeem";
import StarsIcon from "@mui/icons-material/Stars";

const navItems = [
  { title: "Home", to: "/home", icon: <HomeIcon /> },
  { title: "Klientet", to: "/clients", icon: <Groups2OutlinedIcon /> },
  { title: "Transaksionet", to: "/transactions", icon: <PaidIcon /> },
  { title: "Levelet", to: "/levels", icon: <FormatListNumberedRtlIcon /> },
  { title: "Barazimet", to: "/nettingreport", icon: <CurrencyExchangeOutlinedIcon /> },
  { title: "Pikat", to: "/pos", icon: <AddLocationAltIcon /> },
  { title: "Ofertat", to: "/offers", icon: <DiscountIcon /> },
  { title: "Notifikimet", to: "/notifications", icon: <NotificationsActiveIcon /> },
  { title: "Vlera e Pikeve", to: "/bonuspointsvalue", icon: <StarsIcon /> },
  { title: "Voucherat", to: "/voucher", icon: <RedeemIcon /> },
  { title: "Banerat", to: "/banners", icon: <InsertPhotoIcon /> },
  { title: "Groupet", to: "/customergroup", icon: <Groups2OutlinedIcon /> },
];

const Item = ({ title, to, icon, selected, setSelected }) => {
  const location = useLocation();
  const active = location.pathname.toLowerCase() === to.toLowerCase() || selected === title;

  return (
    <MenuItem
      active={active}
      onClick={() => setSelected(title)}
      icon={React.cloneElement(icon, {
        style: {
          color: active ? "#ffffff" : "#8f95a3",
          fontSize: 21,
        },
      })}
      style={{
        background: active ? "#f43f46" : "transparent",
        borderRadius: 10,
        color: active ? "#ffffff" : "#b6bbc6",
        margin: "3px 10px",
      }}
    >
      <Typography variant="h6" fontWeight={active ? 800 : 600}>
        {title}
      </Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Home");

  return (
    <Box
      sx={{
        height: "100vh",
        position: "sticky",
        top: 0,
        zIndex: 40,
        "& .pro-sidebar": {
          minWidth: isCollapsed ? "82px" : "268px",
          width: isCollapsed ? "82px" : "268px",
        },
        "& .pro-sidebar-inner": {
          background: "#0b0d12 !important",
          borderRight: "1px solid rgba(255,255,255,0.08)",
        },
        "& .pro-menu": {
          paddingTop: "8px",
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "10px 16px !important",
          borderRadius: "10px",
        },
        "& .pro-inner-item:hover": {
          backgroundColor: "rgba(255,255,255,0.05) !important",
          color: "#ffffff !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{ color: "#ffffff", margin: "12px 10px 14px" }}
          >
            {!isCollapsed && (
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="h4" color="#ffffff" fontWeight={800} lineHeight={1.1}>
                    Hill Group
                  </Typography>
                  <Typography variant="caption" color="#737782" fontWeight={700}>
                    CMS Control
                  </Typography>
                </Box>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)} sx={{ color: "#9a9da6" }}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          <Box>
            {navItems.map((item) => (
              <Item
                key={item.to}
                title={item.title}
                to={item.to}
                icon={item.icon}
                selected={selected}
                setSelected={setSelected}
              />
            ))}
          </Box>

          {!isCollapsed && (
            <Typography
              variant="caption"
              sx={{
                color: "#626875",
                display: "block",
                fontWeight: 700,
                px: 3,
                py: 2,
              }}
            >
              Powered by Katrori-ITS
            </Typography>
          )}
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
